import { computedFrom, autoinject } from 'aurelia-framework';
import { PageMessageService } from "../../services/page-message-service";
import { WebApiService } from "../../services/web-api-service";
import { SecurityService } from '../../services/security-service';
import { BusyService } from '../../services/busy-service';

@autoinject
export class ChangePassword {
    emailSent: boolean;

    constructor(
        private api: WebApiService,
        private auth: SecurityService,
        private busy: BusyService,
        private pageMessageService: PageMessageService) {
    }

    activate(parameters) {
        this.emailSent = false;
        this.emailAddress = this.auth.user.emailAddress;
    }


    //TODO: This logic is incorrect and should be more diligent in determining the flag, and considering the usage implications.
    // NOTE: Furthermore, a user could start with "%waad" and be SSO for another applicaiton, and username-password for CMP
    @computedFrom("auth.user.userName")
    get isSSOUser(): boolean {
        if (this.auth.user && this.auth.user.userName && this.auth.user.userName.toLocaleLowerCase().indexOf("@nucor.com") > -1) {
            return true;
        }
        return false;
    }


    async sendPwEmail() {
        this.busy.on();
        try {
            this.emailSent = true;
            await this.api.post("Auth", "SendChangePasswordLink");
        } catch {
            this.emailSent = false;
        }
        finally {
            this.busy.off();
        }
    }

    emailAddress: string;

}

